import { useNavigate } from 'react-router-dom';

import { Box, Link, Stack, Text } from '@ekhodealer/ekho-common/rev';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { paths } from '@config/paths';
import { SettingsSection } from '@config/paths/settingsSections';

import { useGetAiBdcSettings } from '../api/useGetAiBdcSettings';

export function CrmReferenceSummary(): React.JSX.Element {
	const navigate = useNavigate();
	const spId = useCurrentServicesProviderId();
	const { data: settings } = useGetAiBdcSettings(spId);

	const crmEmail = settings?.crmEmail;
	const isConfigured = !!crmEmail;

	return (
		<Box padding='24' background='secondary' rounding='12'>
			<Stack itemsSpacing='12'>
				<Stack itemsSpacing='4'>
					<Text size='body' weight='semibold'>
						CRM email
					</Text>
					<Text size='bodySmall' color='secondary'>
						{isConfigured ? crmEmail : 'Not configured'}
					</Text>
				</Stack>
				<Stack itemsSpacing='4'>
					<Text size='body' weight='semibold'>
						Forwarding status
					</Text>
					<Text size='bodySmall' color='secondary'>
						{isConfigured ? 'Enabled' : 'Disabled'}
					</Text>
				</Stack>
				<Text size='bodySmall' color='secondary'>
					CRM forwarding is managed in Integrations settings.
				</Text>
				<Link
					onPress={() =>
						navigate(
							paths.settingsSection.getHref(
								spId,
								SettingsSection.SharedIntegrations,
							),
						)
					}>
					<Text size='bodySmall'>Edit in Integrations settings</Text>
				</Link>
			</Stack>
		</Box>
	);
}
